import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import ExchangeCta from './ExchangeCta';

export default withRouter(withUser(ExchangeCta));
